import React, { useEffect, useState } from "react";
import { API, graphqlOperation } from "aws-amplify";
import { listUsers } from "../../../graphql/queries";
import { updateTask } from "../../../graphql/mutations";

import {
  useNotify,
  useRefresh,
  List,
  SimpleList,
  TopToolbar,
  CreateButton,
  RefreshButton,
  Datagrid,
  TextField,
  Filter,
  SelectField,
  SelectInput,
  Button,
} from "react-admin";
import { useMediaQuery } from "@material-ui/core";

import { Priorities, TaskStatus, TaskTypes } from "../../../utils/constants";

import { logError } from "../../../utils/appUtils";
import { isSubscriptionDisabled } from "../../../utils/appUtils";

import {
  ApproveIcon,
  ChevronRightIcon,
  MyDateField,
} from "../../../components/common/iconography";
import { Empty } from "../../../components/common/Empty";
import { ForceTitle } from "../../../components/common/ForceTitle";
import { Pagination } from "../../../components/Pagination";

const InboundListFilter = ({ setFilters, ...props }) => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    getUsers();
  }, []);

  const getUsers = async () => {
    const response = await API.graphql(graphqlOperation(listUsers));
    setUsers(
      response.data.listUsers.items.map((itm) => ({
        id: itm.id,
        name: itm.fullName,
      }))
    );
    debugger;
  };

  const handleSearch = (event) => {
    const status = event.target.value;
    const newFilter = {
      taskByStatusByAssignedTo: {
        reloadYardId: window.appUser.reloadYardId,
      },
    };
    if (status) {
      newFilter.taskByStatusByAssignedTo.statusAssignedToName = {
        beginsWith: {
          status,
        },
      };
    }
    setFilters(newFilter);
  };

  return (
    <Filter {...props} variant="outlined">
      <SelectInput
        choices={[...TaskStatus].slice(0, 3)}
        allowEmpty={true}
        emptyText="All Tasks"
        onChange={handleSearch}
        source="taskByStatusByAssignedTo.statusAssignedToName.beginsWith.status"
        label="Status"
        alwaysOn
      />
      <SelectInput
        choices={users}
        source="assignedTo.eq"
        label="Assigned To"
        alwaysOn
      />
    </Filter>
  );
};

const ListActions = ({ isXSmall, basePath, ...props }) =>
  !isXSmall ? (
    <TopToolbar>
      <CreateButton basePath={basePath} disabled={isSubscriptionDisabled()} />
      <RefreshButton />
    </TopToolbar>
  ) : null;

export const TaskList = (props) => {
  const isXSmall = useMediaQuery((theme) => theme.breakpoints.down("xs"));
  const isMedium = useMediaQuery((theme) => theme.breakpoints.down("md"));
  debugger;

  const initFilterValues = {
    taskByStatusByAssignedTo: {
      reloadYardId: window.appUser?.reloadYardId,
      statusAssignedToName: { beginsWith: { status: 10 } },
    },
  };

  return (
    <List
      {...props}
      title={<ForceTitle title="Tasks" />}
      filterDefaultValues={initFilterValues}
      filters={<InboundListFilter />}
      sort={{ field: "assignedToName", order: "ASC" }}
      pagination={<Pagination />}
      actions={<ListActions isXSmall={isXSmall} />}
      bulkActionButtons={false}
      syncWithLocation={false}
    >
      <TaskGrid {...props} isXSmall={isXSmall} isMedium={isMedium} />
    </List>
  );
};

const ApproveButton = ({ record }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleClick = async (evt) => {
    evt.preventDefault();
    evt.stopPropagation();

    try {
      debugger;
      record.status = 40;
      record.resolvedDate = new Date().toISOString();
      delete record.updatedAt;
      await API.graphql(graphqlOperation(updateTask, { input: record }));
      refresh();
    } catch (err) {
      logError("tasks:TaskList:ApproveButton:handleClick", err, notify);
    }
  };

  return record?.status < 40 ? (
    <Button label="Approve" color="primary" onClick={handleClick}>
      {<ApproveIcon />}
    </Button>
  ) : null;
};

const TaskGrid = (props) => {
  const { isXSmall, isMedkum } = props;

  if (props.ids.length === 0)
    return <Empty {...props} message="Create a new task" />;
  else
    return isXSmall ? (
      <SimpleList
        primaryText={(record) => record.name}
        secondaryText={(record) => `${record.assignedToName}`}
        tertiaryText={(record) => (
          <SelectField source="status" choices={TaskStatus} record={record} />
        )}
        linkType="edit"
        // leftIcon={record => <UserStatusIcon record={record} />}
        rightIcon={() => (
          <ChevronRightIcon
            fontSize="large"
            color="secondary"
            style={{ marginLeft: 40, marginTop: 10 }}
          />
        )}
      />
    ) : isMedkum ? (
      <Datagrid rowClick="edit">
        <SelectField source="status" choices={TaskStatus} sortable={false} />
        <SelectField source="category" choices={TaskTypes} sortable={false} />
        <TextField source="name" sortable={false} />
        <TextField
          source="assignedToName"
          label="Assigned To"
          sortable={true}
        />
      </Datagrid>
    ) : (
      <Datagrid rowClick="edit">
        <SelectField source="status" choices={TaskStatus} sortable={false} />
        <SelectField source="priority" choices={Priorities} sortable={false} />
        <SelectField source="category" choices={TaskTypes} sortable={false} />
        <TextField source="name" sortable={false} />
        <TextField
          source="assignedToName"
          label="Assigned To"
          sortable={true}
        />
        <MyDateField source="dueDate" sortable={false} />
        <ApproveButton />
      </Datagrid>
    );
};
